export type QuestionFileType = { questionFileUrl: string };
export type TemplateResponseFileType = { questionTemplateFileUrl: string };
export type FrqSubmittedSolutionDocumentType = {
  s3Url: string;
  documentDescription: string;
};
export type McqChoiceType = {
  type: string;
  choiceText: string;
  choiceImgUrl: string;
};

export interface AdminQuestion {
  _id: string;
  customId: string;
  creator: string;
  collaborators: string[];
  tags: string[];
  points: number;
  question: string;
  questionFiles?: QuestionFileType[];
  latexQuestion: boolean;
  updatedAt: string;
  createdAt: string;
}

export interface AdminMcqQuestion extends AdminQuestion {
  choices: McqChoiceType[];
  correctChoiceIndex?: number;
  latexChoices: boolean;
  maxAttempts: number;
  visibility: string;
  [key: string]: any;
}
export interface AdminFreeResponseQuestion extends AdminQuestion {
  templateResponse?: string;
  templateResponseFiles: TemplateResponseFileType[];
  maxAttempts: number;
  isPublic: boolean;
  latexAnswers: boolean;
  [key: string]: any;
}

export interface AdminSubmitMCQPayload extends AdminMcqQuestion {
  [key: string]: any;
}
export interface AdminSubmitFRQPayload extends AdminMcqQuestion {
  [key: string]: any;
}

export enum QuestionType {
  MCQ = "MCQ",
  FRQ = "FRQ",
}